import { render, staticRenderFns } from "./EditTemplateImagem.vue?vue&type=template&id=8662c5d2&scoped=true&"
import script from "./EditTemplateImagem.vue?vue&type=script&lang=js&"
export * from "./EditTemplateImagem.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplateImagem.vue?vue&type=style&index=0&id=8662c5d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8662c5d2",
  null
  
)

export default component.exports